import {
  getRoleList,
  getTree,
  getResource,
  saveResource,
  saveData,
  editData,
  delData,
  getTreeData,
  getUserRole,
  setNewUserRole,
  setOldUserRole
} from '@/api/myweb/organization/roleManagement'
// import { getStatusList } from '@/api/myweb/organization/linkmanManagement'
import { resolveComponent } from 'vue'
export const dataMixin = {
  data() {
    return {
      setmealResourceIdList: [], // 资源id集合
      treeNodesID: ['1453200979751673858'],
      isAdd: true, // 新增or修改
      // showModel: true,
      hasMenu: false, // 弹出框是否具有菜单按钮
      // tabNum: 'name1', // tab当前激活的name
      // userId: '',
      userRoles: [], // 当前角色的所具有资源
      tableData: [],
      selectData: {
        name: ''
      },
      selectObj: {
        name: ''
      },
      data2: [], // 资源树
      resourceIdList: [] // 选中节点id集合
    }
  },
  created() {
    this.getRoleList()
    this.getTree()
    // this.getStatusList()
    // this.getTreeData()
  },
  methods: {
    // 获取列表/查询
    async getRoleList() {
      this.loading2 = true
      this.selectLoading = true
      let res = await getRoleList({
        name: this.selectData.name,
        current: this.pager.current,
        size: this.pager.size
      })
      this.selectLoading = false
      if (res.status) {
        this.tableData = res.data.records
        this.pager.total = res.data.total
      }
      this.loading2 = false
    },
    // 获取资源树
    async getTree() {
      const res = await getTree()
      //console.log(res)
      if (res.status) {
        this.data2 = res.data
        //console.log(this.data2)
        this.$refs.xTable.setCurrentRow(this.tableData[0])
        const rest = await getResource({
          roleId: this.tableData[0].id
        })
        //console.log(res)
        if (res.status) {
          this.userRoles = rest.data
          this.resourceIdList = rest.data
          this.setmealResourceIdList = rest.data
          this.treeChecked(this.data2)
          this.treeCheckeds(this.data2)
          this.setmealResourceIdList.push('1453200979751673858')
          var newArrary = []
          for (var i = 0; i < this.setmealResourceIdList.length; i++) {
            if (this.setmealResourceIdList[i] != 0) {
              newArrary[newArrary.length] = this.setmealResourceIdList[i] //用新数组的长度成为新增添进去的元素的索引下标
            }
          }
          console.log(newArrary)
          newArrary = Array.from(new Set(newArrary))
          console.log(newArrary)
          this.setmealResourceIdList = newArrary
          console.log(this.data2)
          // this.spinShow = true
        }
      }
    },

    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.pager.current = currentPage
      this.pager.size = pageSize
      //console.log(currentPage, pageSize)
      this.getRoleList()
      this.getTree()
    },
    // 角色选中获取权益列表
    async currentChangeEvent({ row }) {
      // this.spinShow = false
      const res = await getResource({
        roleId: row.id
      })
      //console.log(res)
      if (res.status) {
        this.userRoles = res.data
        this.resourceIdList = res.data
        this.setmealResourceIdList = res.data
        this.treeChecked(this.data2)
        console.log(this.data2)
        this.treeCheckeds(this.data2)
        this.setmealResourceIdList.push('1453200979751673858')
        var newArrary = []
        for (var i = 0; i < this.setmealResourceIdList.length; i++) {
          if (this.setmealResourceIdList[i] != 0) {
            newArrary[newArrary.length] = this.setmealResourceIdList[i] //用新数组的长度成为新增添进去的元素的索引下标
          }
        }
        console.log(newArrary)
        newArrary = Array.from(new Set(newArrary))
        console.log(newArrary)
        this.setmealResourceIdList = newArrary
        console.log(this.data2)
        // this.spinShow = true
      }
    },
    // 默认选中菜单
    // eslint-disable-next-line
    treeChecked(list) {
      list.forEach(item => {
        console.log(item)
        console.log(this.userRoles)
        if (this.userRoles.includes(item.id)) {
          this.$set(item, 'checked', true)
          this.setmealResourceIdList.push(item.parentId)
        } else this.$set(item, 'checked', false)
        if (item.children.length !== 0) this.treeChecked(item.children)
      })
    },
    treeCheckeds(list) {
      console.log('88888888888888')
      list.forEach(item => {
        console.log(item)
        console.log(this.setmealResourceIdList)
        if (this.setmealResourceIdList.includes(item.id)) {
          console.log('111111111111111')
          // this.$set(item, 'checked', true)
          this.setmealResourceIdList.push(item.parentId)
        }
        console.log('9999999999999999999')
        // else this.$set(item, 'checked', false)
        // console.log(item.checked, 123123)
        if (item.children.length !== 0) this.treeCheckeds(item.children)
        // console.log('7777777777')
      })
    },
    // 编辑角色权益
    // redact() {
    //   if (this.$refs.xTable.getCurrentRecord() == null) {
    //     this.$Message.warning('请您选中一位角色')
    //   } else {
    //     // this.ISshow = false
    //     // this.ischeck = true
    //   }
    // },
    checkBTN(val) {
      console.log(val, '树变化')
      const treeids = this.$refs.tree.getCheckedAndIndeterminateNodes()
      console.log()
      this.resourceIdList = treeids.map(item => {
        return item.id
      })
      console.log(this.resourceIdList, '处理后的id集合')
    },
    async saveBTN() {
      if (this.$refs.xTable.getCurrentRecord() == null) {
        this.$Message.warning('请您选中一位角色')
      } else {
        console.log(this.resourceIdList, '保存前的id集合')
        // this.ISshow = false
        // this.ischeck = true
        // =================================
        const res = await saveResource({
          roleId: this.$refs.xTable.getCurrentRecord().id,
          resourceIdList: this.resourceIdList
        })
        //console.log(res)
        if (res.status) {
          this.$Message.success('操作成功')
          this.getRoleList()
          this.getTree()
          // this.ISshow = true
          // this.ischeck = false
        }
        // ===========================================
      }
    },
    // cancelBTN() {
    //   // this.ISshow = true
    //   // this.ischeck = false
    // },
    // 查询事件
    selectEvent() {
      this.selectObj = JSON.parse(JSON.stringify(this.selectData))
      this.getRoleList()
      this.getTree()
    },
    // 重置
    resetEvent() {
      this.selectObj = {
        name: ''
      }
      this.selectData = {
        name: ''
      }
      this.getRoleList()
      this.getTree()
    },
    // 新增事件
    addbtn() {
      this.formValidate = {}
      this.$refs.formValidate.resetFields()
      this.isAdd = true
      this.Model = true
    },
    async btnOK(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          this.loading = true
          if (this.isAdd) {
            const res = await saveData({
              name: this.formValidate.name,
              platformCode: 'JP-WSS'
            })
            if (res.status) {
              this.$Message.success('操作成功')
            }
          } else {
            const rest = await editData({
              id: this.formValidate.id,
              name: this.formValidate.name,
              platformCode: 'JP-WSS'
            })
            if (rest.status) {
              this.$Message.success('操作成功')
            }
          }
          //console.log(this.isAdd)
          this.Model = false
          this.loading = false
          this.getRoleList()
          this.getTree()
        }
      })
    },
    btnCANCEL() {
      this.Model = false
    },
    // 修改
    editBTN() {
      if (this.$refs.xTable.getCurrentRecord() == null) {
        this.$Message.warning('请您选中一位角色')
      } else {
        this.isAdd = false
        //console.log(this.$refs.xTable.getCurrentRecord())
        this.formValidate.name = this.$refs.xTable.getCurrentRecord().name
        this.formValidate.id = this.$refs.xTable.getCurrentRecord().id
        this.Model = true
      }
    },
    // 删除
    delBTN() {
      if (this.$refs.xTable.getCurrentRecord() == null) {
        this.$Message.warning('请您选中一位角色')
      } else {
        this.Model1 = true
      }
    },
    async delok() {
      this.loading1 = true
      //console.log(this.formValidate.id)
      const res = await delData({ id: this.$refs.xTable.getCurrentRecord().id })
      if (res.status) {
        this.Model1 = false
        this.loading1 = false
        this.$Message.success('操作成功')
        this.getRoleList()
        this.getTree()
      }
      this.loading1 = false
    },
    delCANCEL() {
      this.Model1 = false
    },
    // 尚亚丹写的
    editEvent(row) {
      this.userId = row.id
      //console.log(this.userId)
      if (row.status === 0) {
        this.hasMenu = true
        this.getUserRole(this.userId)
      } else {
        this.hasMenu = false
      }
      //console.log(row)
      this.showModel = true
      this.isAdd = false
      this.tabNum = 'name1'
      this.modelData = JSON.parse(JSON.stringify(row))
      this.modelData.status += ''
    },
    // 模态框提交
    async saveEvent(num) {
      let data = {
        name: this.modelData.name,
        status: this.modelData.status,
        remark: this.modelData.remark
      }
      if (!this.isAdd) {
        data.id = this.modelData.id
      }
      if (num) {
        data.id = this.userId
        this.closeLoading = true
      } else {
        this.saveLoading = true
      }
      //console.log(data)
      let res = await saveData(data)
      this.saveLoading = false
      this.closeLoading = false
      if (res.code === 0) {
        //console.log(res)
        this.$Message.success('保存成功')
        // 判断是否为新增
        if (this.isAdd) {
          this.userId = res.data
          //console.log(this.userId)
          this.hasMenu = true
          this.tabNum = 'name2'
        } else {
          // 为修改时
          // this.showModel = false
        }
        if (num) {
          this.showModel = false
        }
        this.getRoleList()
        this.getTree()
        this.getUserRole(res.data.id)
        this.userId = res.data.id
      } else {
        // this.$Message.error(res.message)
      }
    },
    // 获取树状解构
    async getTreeData() {
      let res = await getTreeData()
      //console.log(res)
      //console.log(res.data, '树结构')
      this.baseData = [res.data]
      this.copy = JSON.parse(JSON.stringify(this.baseData))
      this.treeChecked(this.baseData)
    },
    // 树状数据处理
    renderContent(h, { root, node, data }) {
      return h(
        'span',
        {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        },
        // [
        //   h('span', [
        //     h('Icon', {
        //       class: data.icon,
        //       // custom: 'iconfont icon-a-lujing268',
        //       // type: 'md-add',
        //       style: {
        //         marginRight: '8px'
        //       }
        //     }),
        //     h('span', data.name),
        //   ]),
        // ],
        [
          h('span', [h('span', data.name)]),
          h('span', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '32px'
            }
          })
        ]
      )
    },
    //  查询该用户菜单列表
    async getUserRole(roleId) {
      let res = await getUserRole({ roleId })
      //console.log(res, '结果')
      this.userRoles = res.data.map(item => {
        return item.id
      })
      //console.log(this.userRoles)
      this.getTreeData()
    },
    // 树状解构保存
    async saveMenu() {
      this.menuLoading = true
      let resourceIds = this.$refs.tree
        .getCheckedAndIndeterminateNodes()
        .map(item => {
          return item.id
        })
      // 如果为新增
      let res_1
      resourceIds = resourceIds.join(',')
      //console.log(resourceIds)
      if (this.isAdd) {
        res_1 = await setNewUserRole({
          roleId: this.userId,
          resourceIds
        })
      } else {
        res_1 = await setOldUserRole({
          roleId: this.userId,
          resourceIds
        })
      }
      //console.log(res_1)
      this.menuLoading = false
      if (res_1.code === 0) {
        this.showModel = false
      } else {
        // this.$Message.error(res_1.message)
      }
    },
    // 树状结构重置
    resetMenu() {
      // this.$nextTick(() => this.treeChecked(this.copy))
      // this.getTreeData()
      this.baseData = JSON.parse(JSON.stringify(this.copy))
      this.treeChecked(this.baseData)
    }
  }
}
